import { API_END_POINTS_MODELS } from "../Models/ApiEndPointModels";

const API_END_POINTS: API_END_POINTS_MODELS = {
  LOGIN: "/api/account/login/",
  REFRESH_TOKEN: "/api/account/refresh/",
  TUTOR_REGISTRATION: "/api/user/register/",
  VERIFY_OTP: "/api/services/verify_otp/",
  VERIFY_LOGIN_OTP: "/api/services/verify_login_otp/",
  RESEND_OTP: "/api/user/resend_otp/",
  FORGOT_PASSWORD: "/api/account/forgotpassword/",
  RESET_PASSWORD: "/api/account/resetpassword/",
  CREATE_CATEGORY: "/api/admin/category/",
  GET_CATEGORY_LIST: "/api/admin/categorylist/",
  DELETE_CATEGORY: "/api/admin/category/",
  GET_CATEGORY_DATA: "/api/admin/category/",
  DASHBOARD: "/api/services/dashboard/",
  SCHOOL_BULK_UPLOAD: "/api/admin/school/",
  GET_SCHOOL_LIST: "/api/admin/school_list/",
  ADMIN_DETAIL: "/api/admin/profile/",
  UPDATE_PASSWORD: "/api/account/updatepassword/",
  GET_RECREATIONAL: "/api/admin/recreational_category_list/",
  CREATE_TAGS: "/api/admin/tag/",
  GET_TAG_DETAIL: "/api/admin/tag/",
  CREATE_ACCOUNT: "/api/services/send_otp/",
  LOGIN_API: "/api/services/send_login_otp/",
  CATEGORIES_LIST: "/api/admin/allcoursecategory/",
  BASIC_INFORMATION: "/api/services/tutor_basic_register/",
  RECREATIONAL_CATEGORY: "/api/admin/allrecreationalcategory/",
  GET_SPDETAILS: "/api/services/tutor_profile/",
  PERSONAL_BASIC_REGISTER: "/api/services/recreational_personal_basic_register/",
  PERSONAL_PROFESSIONAL_REGISTER: "/api/services/recreational_personal_professional_register/",
  PERSONAL_VERIFY: "/api/services/recreational_personal_professional_register/",
  CAMP_BASIC_REGISTER: "/api/services/recreational_camp_basic_register/",
  CAMP_PROFESSIONAL_REGISTER: "/api/services/recreational_camp_professional_register/",
  GET_CAMP_DETAILS: "/api/services/recreational_camp_user_profile/",
  CAMP_VERIFY: "/api/services/recreational_camp_professional_register/",
  GET_PERSONAL_DETAILS: "/api/services/recreational_personal_user_profile/",
  GET_RECREATIONAL_CATEGORY: "/api/services/recreational_category/",
  TUTOR_VERIFY: "/api/services/tutor_professional_register/",
  TUTOR_CATEGORY: "/api/services/tutor_category/",
  CREATE_SESSION: "/api/services/create_session_slot/",
  SESSIONS_LIST: "/api/services/session_slot/",
  UPDATE_SESSION: "/api/services/update_slot/",
  CURRICULAM_LIST: "/api/services/curriculam_list/",
  FIRST_LOGIN: "/api/services/first_time_login/",
  APPROVAL_REFRESH: "/api/services/approval_refresh/",
  SLOT_DETAIL: "/api/services/session_slot_detail/",
  TERMS_AND_CONDITIONS: "/api/admin/termsandconditions/",
  GET_GRADES_LIST: "/api/services/grade/",
  PERSONAL_CATEGORY: "/api/services/personal_user_category/",
  CAMP_CATEGORY: "/api/services/camp_user_category/",
  SCHOOL_UNIVERSITY_REGISTRATION: "/api/services/authority_registration/",
  SCHOOL_UNIVERSITY_STEPPERS: "/api/services/authority_registration_next/",
  SCHOOL_UNIVERSITY_DETAILS: "/api/services/authority_profile/",
  UNIVERSITY_API: "/api/admin/univerisity/",
  BOOKINGS_LIST: "/api/services/booked_sessions/",
  BOOKING_DETAILS: "/api/services/booked_time_slots/",
  NOTIFICATIONS_LIST: "/api/services/serviceprovider_notification_list/",
  NOTIFICATION_READ: "/api/services/serviceprovider_notification/",
  CHAT_USERS_LIST: "/api/services/chat_users_list/",
  CREATE_CHAT_ROOM: "/api/user/chat_room/",
  CHAT_HISTORY: "/api/user/chat_history/",
  COVER_IMAGE: "/api/services/cover_images/",
  TUTOR_PROFILE_UPDATE: "/api/services/tutor_professional_info_update/",
  CAMP_PROFILE_UPDATE: "/api/services/camp_professional_info_update/",
  TRAINER_PROFILE_UPDATE: "/api/services/personal_professional_info_update/",
  DISCOUNT_FILTER_DATA: "/api/services/document_upload/",
  DISCOUNT_FILTERED_LIST: "/api/services/documents_session_list/",
  EXPERTS_BASIC_REGISTER: "/api/services/educational_expert_basic_register/",
  EXPERTS_REGISTRATION: "/api/services/educational_expert/",
  ENABLE_ATTENDENCE: "/api/services/attendance/",
  AMINITY_LIST: "api/services/amenities_list/",
  EMIRATE_LIST: "api/admin/emirate_city_list/?parent_id=0",
  CANCEL_REQUEST_LIST: "/api/services/user_cancellation_request/",
  PAST_CANCEL_REQUESTS: "/api/services/slot_cancellation_list/",
  SET_USER_READ_CHAT: "/api/user/chat_read/",
  BOOKING_VALIDATION: "/api/services/booking_validation/",
  HIGHEST_QUALIFICATION_LIST: "/api/admin/highest_qualification_list/",
  CAMP_DISCOUNT_LIST: "/api/services/camp_discount_list/",
  MANAGE_CAMPS_DISCOUNT: "/api/services/camp_manage_discount/",
  TUTOR_CANCEL_SLOT: "/api/services/tutor_cancel/",
  RESHEDULE_SLOT: "api/services/service_provider_reschedules/",
  AWS_CREDENTIALS_LIST: "/api/user/s3credentials/",
  S3_STATIC_UPLOAD: "/api/user/staticupload/",
  RESCHEDULE_LIST:"/api/services/tutorsession_slot_list/",
  PT_RECHEDUL_LIST:"/api/services/recreational_pt_sessionlist/",
  MANAGE_CATEGORY: "api/services/managecategory/",
};

export default API_END_POINTS;
